import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const heroProducts = productData.slice(0, 3);
  const bestSellers = productData.slice(3, 8);

  return (
    <div className="main">
      <main>
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">Back in Stock</h1>
            <p className="hero-subtitle">Cult favorite pens and more</p>
            <Link to="/shop" onClick={toTop} className="hero-button">
              Shop Now
            </Link>
          </div>
          <div className="hero-image">
            <img
              src="/generated/site/hero.jpg"
              alt="Original stationery collection"
            />
          </div>
        </section>

        {/* Categories Section */}
        <section className="categories-section">
          <div className="categories-container">
            <div className="category-item">
              <div className="category-image-wrapper">
                <img
                  src="/generated/site/category-cases.jpg"
                  alt="Pen & Pencil Cases"
                />
              </div>
              <h3 className="category-title">Pen & Pencil Cases</h3>
            </div>
            <div className="category-item">
              <div className="category-image-wrapper circle">
                <img
                  src="/generated/site/category-fountain-pens.jpg"
                  alt="Fountain Pens"
                />
              </div>
              <h3 className="category-title">Fountain Pens</h3>
            </div>
            <div className="category-item">
              <div className="category-image-wrapper circle">
                <img
                  src="/generated/site/category-mechanical-pencils.jpg"
                  alt="Mechanical Pencils"
                />
              </div>
              <h3 className="category-title">Mechanical Pencils</h3>
            </div>
            <div className="category-item">
              <div className="category-image-wrapper">
                <img
                  src="/generated/site/category-notebooks.jpg"
                  alt="Notebooks & Notepads"
                />
              </div>
              <h3 className="category-title">Notebooks & Notepads</h3>
            </div>
            <div className="category-item">
              <div className="category-image-wrapper circle">
                <img
                  src="/generated/site/category-bundles.jpg"
                  alt="Original Bundles"
                />
              </div>
              <h3 className="category-title">Original Bundles</h3>
            </div>
          </div>
        </section>

        {/* Spotlight Section */}
        <section className="spotlight-section">
          <div className="spotlight-left">
            <div className="spotlight-image-container">
              <img
                src="/generated/site/spotlight.jpg"
                alt="Premium original stationery"
              />
            </div>
            <div className="spotlight-overlay">
              <p className="spotlight-label">SLAYFULPAWSCO SPOTLIGHT</p>
              <h2 className="spotlight-title">PREMIUM EVERYDAY STATIONERY</h2>
              <Link to="/shop" onClick={toTop} className="spotlight-button">
                Explore More
              </Link>
            </div>
          </div>
          <div className="spotlight-right">
            <div className="spotlight-products">
              {heroProducts.map((product, index) => (
                <Link
                  to={`/shopDetails/${product.id}`}
                  key={product.id}
                  className="spotlight-product"
                >
                  <div className="product-image">
                    <img src={product.homepageImage} alt={product.name} />
                  </div>
                  <p className="product-brand">slayfulpawsco</p>
                  <p className="product-name">{product.name}</p>
                  <div className="product-rating">
                    <span className="stars">★★★★★</span>
                    <span className="rating-score">5.0</span>
                  </div>
                  <p className="product-price">${product.price}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Best Sellers Section */}
        <section className="bestsellers-section">
          <div className="bestsellers-header">
            <h2 className="bestsellers-title">BEST SELLERS</h2>
          </div>
          <div className="bestsellers-grid">
            {bestSellers.map((product, index) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                className="bestseller-item"
              >
                <div className="bestseller-image">
                  <img src={product.homepageImage} alt={product.name} />
                  {index === 3 && (
                    <span className="limited-badge">Limited</span>
                  )}
                </div>
                <p className="bestseller-brand">slayfulpawsco</p>
                <p className="bestseller-name">{product.name}</p>
                <div className="bestseller-rating">
                  <span className="stars">★★★★★</span>
                  <span className="rating-score">5.0</span>
                </div>
                <p className="bestseller-price">${product.price}</p>
              </Link>
            ))}
          </div>
        </section>

        {/* Discover Section */}
        <section className="discover-section">
          <div className="discover-container">
            <div className="discover-image">
              <img
                src="/generated/site/discover.jpg"
                alt="Precision pencil on an architect's desk"
              />
            </div>
            <div className="discover-content">
              <p className="discover-label">DISCOVER</p>
              <h2 className="discover-title">
                Built to Last: The Details Behind a Precise Mechanical Pencil
              </h2>
              <Link to="/about" onClick={toTop} className="discover-button">
                Read More
              </Link>
            </div>
          </div>
        </section>

        {/* Recent Reviews Section */}
        <section className="reviews-section">
          <div className="reviews-header">
            <h2 className="reviews-title">Recent Reviews</h2>
          </div>
          <div className="reviews-container">
            <div className="reviews-grid">
              <div className="review-card">
                <div className="review-image">
                  <img
                    src="/generated/site/review-green-pen.jpg"
                    alt="Forest green gel pen"
                  />
                </div>
                <p className="review-text">
                  Pen writes very smoothly. Weight of the pen is good.
                </p>
                <div className="review-rating">
                  <span className="stars">★★★★★</span>
                </div>
                <p className="review-author">Tess ✔</p>
                <p className="review-product">Everyday Gel Pen...</p>
              </div>
              <div className="review-card">
                <div className="review-image">
                  <img
                    src="/generated/site/review-coral-pen.jpg"
                    alt="Coral metal pen"
                  />
                </div>
                <p className="review-text">
                  This is sleek and feels great in the hand. The ink flows
                  nicely an...
                </p>
                <div className="review-rating">
                  <span className="stars">★★★★★</span>
                </div>
                <p className="review-author">Chris F. ✔</p>
                <p className="review-product">Quick-Dry Gel Pen...</p>
              </div>
              <div className="review-card">
                <div className="review-image">
                  <img
                    src="/generated/site/review-navy-pen.jpg"
                    alt="Navy rollerball pen"
                  />
                </div>
                <p className="review-text">
                  The feel, weight, and smoothness of the ink flow, make this
                  an...
                </p>
                <div className="review-rating">
                  <span className="stars">★★★★★</span>
                </div>
                <p className="review-author">Anonymous ✔</p>
                <p className="review-product">Meridian Rollerball...</p>
              </div>
              <div className="review-card">
                <div className="review-image">
                  <img
                    src="/generated/site/review-graphite-pencil.jpg"
                    alt="Graphite mechanical pencil"
                  />
                </div>
                <p className="review-text">
                  Very nice pencil, works nicely and has little to no tip
                  wobble.
                </p>
                <div className="review-rating">
                  <span className="stars">★★★★★</span>
                </div>
                <p className="review-author">Nico M. ✔</p>
                <p className="review-product">Precision Metal Pencil...</p>
              </div>
              <div className="review-card">
                <div className="review-image">
                  <img
                    src="/generated/site/review-blue-glass-pen.jpg"
                    alt="Blue glass dip pen"
                  />
                </div>
                <p className="review-text">
                  This is by no means a bad pen... but for the price, it's
                  rather...
                </p>
                <div className="review-rating">
                  <span className="stars">★★★★☆</span>
                </div>
                <p className="review-author">Anonymous ✔</p>
                <p className="review-product">Starlit Ocean Glass Dip Pen...</p>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="features-container">
            <div className="feature-item">
              <div className="feature-icon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M12 2L2 7l10 5 10-5-10-5z" />
                  <path d="M2 17l10 5 10-5" />
                  <path d="M2 12l10 5 10-5" />
                </svg>
              </div>
              <div className="feature-content">
                <h3 className="feature-title">THOUGHTFULLY CURATED</h3>
                <p className="feature-description">
                  Selected for useful details, satisfying materials, and
                  everyday joy
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
              </div>
              <div className="feature-content">
                <h3 className="feature-title">ORIGINAL COLLECTION</h3>
                <p className="feature-description">
                  Distinct designs presented without third-party branding
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <div className="feature-content">
                <h3 className="feature-title">FREE EXPRESS SHIPPING</h3>
                <p className="feature-description">
                  Free express shipping available
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div className="feature-content">
                <h3 className="feature-title">TRUSTED BY STATIONERY LOVERS</h3>
                <p className="feature-description">
                  Chosen by thousands of stationery enthusiasts worldwide
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Main;
